class Group {
    id: number;
    schoolId: number;
    campusID?: number;
    termDatesID?: number;
    name: string;
    createdOn: Date;
    createdBy: number;
    editedOn: Date;
    editedBy: number;
    recycledOn: Date;
    recycledBy: number;

    constructor(data?: Partial<Group>) {
        Object.assign(this, data);
        
        if (typeof this.createdOn === "string")
            this.createdOn = new Date(this.createdOn);

        if (typeof this.editedOn === "string")
            this.editedOn = new Date(this.editedOn);

        if (typeof this.recycledOn === "string")
            this.recycledOn = new Date(this.recycledOn);
    }
}

export default Group;